import { FaPhoneAlt,  } from "react-icons/fa";

export default function FloatingContact() {
  return (
    <div className="fixed right-5 bottom-6 z-50 flex flex-col items-end gap-4">

  


      {/* Call */}
      <a
        href="tel:+916393561379"
        className="group relative"
      >
        {/* Pulse Ring */}
       <span className="absolute inset-0 hidden md:block rounded-full bg-green-400 animate-ping opacity-30"></span>

        {/* Button */}
        <div className="
          relative  w-11 h-11 md:h-14 md:w-14  rounded-full
          bg-[#19bd26]
          text-white flex items-center justify-center
          shadow-[0_10px_30px_rgba(0,0,0,0.25)]
          backdrop-blur-xl
          border border-white/20
          transition-all duration-500
          group-hover:scale-110
          group-hover:shadow-green-500/50
        ">
          <FaPhoneAlt size={18}/>
        </div>

        {/* Tooltip */}
        <span className="
          absolute right-16 top-1/2 -translate-y-1/2
          bg-black text-white text-xs px-3 py-1.5
          rounded-lg opacity-0 group-hover:opacity-100
          transition whitespace-nowrap
        ">
          Call Now
        </span>
      </a>

    </div>
  );
}